<template>
  <el-form label-width="120px" class="demo-dynamic" label-position="top">
    <div class="keywords-title">
      {{$t('feed.settings.keys.title')}}
    </div>
    <div class="keywords-list-un-enabled" v-if="!isEnabledKeyWords && !loading">
      {{$t('feed.settings.keys.empty')}}
    </div>
    <div v-loading="loading" class="loading-text"></div>
    <div class="keywords-filter-list-wrap" v-if="isEnabledKeyWords" v-bar>
      <div class="keywords-filter-list">
        <keys-filter-item
          v-for="(item, index) in keywords"
          :key="item.keyword"
          :index="index"
          :item="item"
          :references-networks="referencesNetworks"
          @enableKeyWord="enableKeyWord"
          @deleteKeyWordFilter="deleteKeyWord"
          @choiceNetwork="choiceNetwork"
          @editKeyWord="editKeyWord"
        />
      </div>
    </div>
    <el-form-item>
      <el-button @click="addKeyWord" type="primary">{{$t('feed.settings.keys.button')}}</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
  import KeysFilterItem from '@/views/feedSettings/components/settings/tabs/forms/components/KeysFilterItem';
  export default {
    name: 'KeysFilter',
    components: {
      KeysFilterItem
    },
    props: {
      keywords: {
        type: Array
      },
      referencesNetworks: {
        type: Array
      },
      loading: {
        type: Boolean
      }
    },
    computed: {
      isEnabledKeyWords() {
        return this.keywords.length;
      },
    },
    methods: {
      deleteKeyWord(index) {
        this.$emit('deleteKeyWord', index);
      },
      addKeyWord() {
        this.$emit('addKeyWord');
      },
      enableKeyWord(options) {
        this.$emit('enableKeyWord', options);
      },
      editKeyWord(options) {
        this.$emit('editKeyWord', options);
      },
      choiceNetwork(options) {
        this.$emit('choiceNetwork', options);
      }
    },
  };
</script>

<style>
  .keywords-filter-list-wrap {
    position: relative;
    margin-bottom: 15px;
    padding-right: 4px;
    max-height: 600px;
    overflow-y: auto!important;
    scrollbar-color: rgb(103, 163, 227) rgb(229, 229, 226);
  }
  .keywords-filter-list-wrap::-webkit-scrollbar {
    width: 12px;
  }

  .keywords-filter-list-wrap::-webkit-scrollbar-track {
    background: rgb(229, 229, 226);
  }

  .keywords-filter-list-wrap::-webkit-scrollbar-thumb {
    background-color: rgb(103, 163, 227);
    border-radius: 20px;
    border: 3px solid rgb(229, 229, 226);
  }
  .keywords-filter-list {
    display: flex!important;
    justify-content: space-between;
    align-items: flex-start;
    flex-wrap: wrap;
    width: 100%;
    /*max-height: 600px;*/
    /*overflow-y: auto;*/
  }
  .keywords-title {
    font-family: "Roboto", "Arial", sans-serif;
    font-style: normal;
    font-weight: 300;
    font-size: 14px;
    line-height: 14px;
    margin-bottom: 15px;
  }
  .keywords-list-un-enabled {
    font-family: "Roboto", "Arial", sans-serif;
    font-style: normal;
    font-weight: 300;
    font-size: 14px;
    line-height: 14px;
    margin-bottom: 48px;
    color: #5E6D82;
  }
  .el-icon-cursor {
    cursor: pointer;
  }
</style>
